export const domain = process.env.DOMAIN || "localhost";
